"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuLogo = _interopRequireDefault(require("./MenuV1/MenuLogo"));
var _Menu = _interopRequireDefault(require("./MenuV1/Menu"));
var _MenuItemsList = require("./MenuV1/MenuItemsList");
var _excluded = ["menuItems", "whiteLabel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AirturnLogoText = function AirturnLogoText(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", {
    id: "logo-text"
  }, "Logo text"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.844 26.29a3 3 0 01-.25-.85 3.07 3.07 0 01-2.4 1 3.36 3.36 0 01-2.27-.78 2.61 2.61 0 01-.92-2 2.7 2.7 0 011.12-2.33 5.57 5.57 0 013.24-.81h1.17v-.55a1.57 1.57 0 00-.34-1.06 1.32 1.32 0 00-1.06-.39 1.49 1.49 0 00-1 .31 1 1 0 00-.37.84h-2.6c0-.55.18-1.087.51-1.53a3.31 3.31 0 011.44-1.1 5.24 5.24 0 012.1-.4 4.15 4.15 0 012.79.88 3.1 3.1 0 011 2.49v4.12a4.54 4.54 0 00.41 2.03v.15l-2.57-.02zm-2.1-1.77a2.16 2.16 0 001-.25 1.57 1.57 0 00.7-.67v-1.64h-1c-1.27 0-2 .44-2 1.32v.15a1 1 0 00.34.79 1.3 1.3 0 00.96.3zM14.154 14.31a1.26 1.26 0 01.38-.94 1.45 1.45 0 011-.37 1.4 1.4 0 011 .37c.26.243.401.586.39.94a1.25 1.25 0 01-.39.95 1.63 1.63 0 01-2.07 0 1.25 1.25 0 01-.31-.95zm2.7 12h-2.55v-9.54h2.55v9.54zM24.484 19.16a6.56 6.56 0 00-.92-.07 1.86 1.86 0 00-1.89 1v6.23h-2.54v-9.55h2.4l.07 1.14a2.35 2.35 0 012.12-1.31 2.52 2.52 0 01.79.11l-.03 2.45zM29.364 14.43v2.34h1.63v1.87h-1.63v4.75c-.024.271.05.541.21.76a1 1 0 00.77.22 4.22 4.22 0 00.75-.06v1.93a5.32 5.32 0 01-1.54.23 2.43 2.43 0 01-2.73-2.7v-5.13h-1.39v-1.87h1.39v-2.34h2.54zM38.294 25.32a3.18 3.18 0 01-2.6 1.15 3 3 0 01-2.34-.88 3.75 3.75 0 01-.82-2.58v-6.24h2.54v6.16c0 1 .45 1.49 1.35 1.49a1.83 1.83 0 001.78-.9v-6.75h2.55v9.52h-2.39l-.07-.97zM48.204 19.16a6.33 6.33 0 00-.91-.07c-.781-.099-1.54.301-1.9 1v6.23h-2.54v-9.55h2.4l.07 1.14a2.35 2.35 0 012.12-1.31c.27-.005.54.032.8.11l-.04 2.45zM51.924 16.77l.07 1.1a3.35 3.35 0 012.74-1.27 2.76 2.76 0 012.25.88 4.11 4.11 0 01.79 2.68v6.15h-2.54v-6.15a1.65 1.65 0 00-.31-1.13 1.61 1.61 0 00-1.17-.37 1.74 1.74 0 00-1.61.92v6.71h-2.59v-9.52h2.37z"
  })));
};
AirturnLogoText.defaultProps = {
  width: "62",
  height: "40",
  viewBox: "0 0 62 40",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
var AirturnLogoIcon = function AirturnLogoIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", {
    id: "logo-icon"
  }, "Logo Icon"), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "49.923%",
    y1: "5.066%",
    x2: "49.923%",
    y2: "125.599%",
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#4A69FF",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#435EFC",
    offset: "27%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#394EF8",
    offset: "56%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#3343E8",
    offset: "76%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#2A33D0",
    offset: "100%"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    x1: "50.091%",
    y1: "-122.177%",
    x2: "50.091%",
    y2: "160.855%",
    id: "b"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#4A69FF",
    offset: "0%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#435EFC",
    offset: "27%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#394EF8",
    offset: "56%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#3343E8",
    offset: "76%"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#2A33D0",
    offset: "100%"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "1",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.93 14.79a.34.34 0 01-.3-.49l2-4.07L18.19.92a1 1 0 011.83 0l4.56 9.31 7.19 14.7c.12.26 0 .59-.29.59H29a2 2 0 01-1.74-1.18l-6.9-14.11-1.29-2.54-1.24 2.54-2.12 4.37a.32.32 0 01-.3.19h-3.48z",
    fill: "url(#a)",
    transform: "translate(1 7)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.21 16.66h12.17a2 2 0 110 4h-4.66l-1.78 3.64a2 2 0 01-1.83 1.14H6.68a.34.34 0 01-.31-.44l2.1-4.29h-4.2a2.11 2.11 0 01-1.83-1.06L.26 15.2a.34.34 0 01.31-.49H3a2 2 0 011.83 1.15l.38.8z",
    fill: "url(#b)",
    transform: "translate(1 7)"
  })));
};
AirturnLogoIcon.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
var propTypes = {
  /** An array of menu items */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_MenuItemsList.menuItemShape)),
  /** The image source and description for white-labeling */
  whiteLabel: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  })
};
exports.propTypes = propTypes;
var AirturnMenuLogo = function AirturnMenuLogo(props) {
  return /*#__PURE__*/_react["default"].createElement(_MenuLogo["default"], _extends({
    icon: AirturnLogoIcon,
    text: AirturnLogoText,
    mB: "m"
  }, props));
};
var AirturnMenu = function AirturnMenu(_ref) {
  var menuItems = _ref.menuItems,
    whiteLabel = _ref.whiteLabel,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Menu["default"], _extends({
    logo: AirturnMenuLogo,
    menuItems: menuItems,
    whiteLabel: whiteLabel,
    wrapperProps: {
      activeVariant: "dot"
    }
  }, other));
};
AirturnMenu.propTypes = propTypes;
var _default = AirturnMenu;
exports["default"] = _default;